import axios from 'axios'

let baseUrl = 'https://yunthee.com/website-dev'

//公司Logo查询
export function getLogo() {
	return axios.get(baseUrl + '/website/logo/get')
}

//解决方案信息
export function getSolve() {
	return axios.get(baseUrl + '/website/solution/get')
}

//产品服务
export function getServer() {
	return axios.get(baseUrl + '/website/service/get')
}

//首页客户案轮播
export function indexCaseBanner() {
	// return
	// new Promise((resove, reject) => {
	//   axios.get(baseUrl + '/website/case/get').then(res => {
	//     console.log(res)
	//     resove(res)
	//   })
	// })

	return axios.get(baseUrl + '/website/case/get')
}

//单个解决方案查询
export function getSolveOne(sid) {
	return axios.get(baseUrl + '/website/solution/one/' + sid)
}

//解决方案列表查询
export function getSolveList() {
	return axios.get(baseUrl + '/website/solution/get')
}

//单个产品服务查询
export function getServeOne(sid) {
	return axios.get(baseUrl + '/website/service/one/' + sid)
}

//产品服务列表查询
export function getServeList() {
	return axios.get(baseUrl + '/website/service/get')
}

//客户案例列表查询
export function getCaseList() {
	return axios.get(baseUrl + '/website/case/get')
}

//新闻列表查询
export function getNewsList() {
	return axios.get(baseUrl + '/website/news/get')
}

//单个新闻查询
export function getNewsOne(sid) {
	return axios.get(baseUrl + '/website/news/one/' + sid)
}

//单个新闻查询
export function getRecruitmentList() {
	return axios.get(baseUrl + '/website/recruitment/get')
}

//获取公司合照
export function getTeaPhoto() {
	return axios.get(baseUrl + '/website/activity/get')
}

//获取公司友情链接
export function getFriend() {
	return axios.get(baseUrl + '/website/link/get')
}

//获取公司banner
export function getBanner(name) {
	return axios.get(baseUrl + '/website/' + name + '/banner')
}
